import { ActivityCategory } from '@surecompanies/activity-log'
import { logActivity } from 'modules/activity-log'
import { SOURCE } from 'modules/activity-log/constants'
import {
  ActivityActorAndTarget,
  getActorAndTarget,
} from 'modules/activity-log/get-actor-and-target'
import { storeInstance } from 'store/createStore'
import { isImpersonating } from 'store/modules/user-session/selectors'

export const formatDescription = ({
  activity,
  actorAndTarget,
  state,
}: {
  activity: string
  actorAndTarget: ActivityActorAndTarget
  state: unknown
}): string => {
  if (isImpersonating(state)) {
    return `${actorAndTarget.actorName} ${activity} on behalf of ${actorAndTarget.targetName}`
  }
  return `${actorAndTarget.actorName} ${activity}`
}

interface LogActivityInput {
  additionalData?: Record<string, unknown>
  activity: string
  action: string
}

/**
 * Log a generic activity
 * @param {Record<string, any>} additionalData - additional data to include in the log
 * @param {string} activity - the human-readable description of the activity. e.g. 'viewed the Shop for Health page'
 * @param {string} action - categorizes identical or similar activities. e.g. 'ShopForHealthViewed'
 */
export const logGenericActivity = ({ additionalData = {}, activity, action }: LogActivityInput) => {
  const state = storeInstance.getState()
  const actorAndTarget = getActorAndTarget(state)
  if (!actorAndTarget) {
    console.warn(`logged in user could not be determined`)
    return
  }

  return logActivity({
    ...actorAndTarget,
    source: SOURCE,
    category: ActivityCategory.UserInteraction,
    action,
    description: formatDescription({ activity, actorAndTarget, state }),
    additionalData: { urlPath: window?.location?.pathname, ...additionalData },
  }).catch(console.error)
}
